import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		text: {
			marginBottom: theme.spacing(0.5),

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ mobileAlignment }) => mobileAlignment,
			},
		},

		container: {
			'&:hover': {
				cursor: ({ isBuilderMode }) => (isBuilderMode ? 'default' : 'pointer'),
			},
			position: 'relative',
			width: '100%',
			marginBottom: theme.spacing(2),
		},

		image: {
			display: 'block',
			paddingTop: '57.6%',

			'& picture': {
				width: '100%',
			},

			'& img': {
				position: 'absolute',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				width: '100%',
				objectFit: 'cover',
			},
		},

		button: {
			position: 'absolute',
			top: '0',
			left: '0',
			right: '0',
			bottom: '0',

			'&:hover': {
				backgroundColor: 'transparent',
			},
		},

		playIcon: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			width: 34,
			height: 40,
			color: theme.palette.common.white,
			pointerEvents: 'all',
			zIndex: 1,
		},
	}),
	{ name: 'Video-Video8-item' },
)

export default useStyles
